export const QueryKey = {
	GET_STATIC_CONTENT: 'GetStaticContent',
	GET_SPACEX_LAUNCHES: 'GetSpaceXLaunches',
	GET_BUSINESS_INFO: 'GetBusinessInfo',
	GET_MEMBER_CONTACT: 'GetMemberContact',
	GET_MEMBER_TERMS: 'GetMemberTerms',
	GET_FAQS: 'GetFAQs',
	GET_EDITORIALPOLICY: 'GetEditorialPolicy',
	GET_MEMBER_AGREEMENTS: 'GetMemberAgreements',
};
